var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert-container",attrs:{"data-testid":"alert"}},[_c('v-snackbar',{attrs:{"value":_vm.snackbar,"top":"","right":"","color":_vm.type}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }